import "../Static Files/styles/Navbar And Footer/navbarAndFooter.css";
import logo from "../Static Files/Images/HomePage/Logo Transparent.png";
import { NavLink, useLocation } from "react-router-dom";
import translation from "../locales";

const Footer = () => {
  const location = useLocation();

  const lang = location.pathname.split("/")[1];
  const currentLang = translation[lang] ? lang : "az";

  const footerStyle = {
    marginTop: location.pathname === "/contact" ? "0vw" : "22vw",
  };
  return (
    <>
      <footer style={footerStyle}>
        <div className="footer-body">
          <div className="company-div">
            <ul>
              <li>
                <NavLink to={`/${currentLang}/`}>
                  <img src={logo} alt="logo" />
                  <h2>Joyful Travel</h2>
                </NavLink>
              </li>
              <li>
                <p>
                  It is very important that the customer can get some customer
                  support
                </p>
              </li>
            </ul>
          </div>
          <div className="transitions-div">
            <h2>{translation[currentLang].footertransitions}</h2>
            <ul>
              <li>
                <NavLink to={`/${currentLang}/`} >
                {translation[currentLang].home}
                </NavLink>
              </li>
              <li>
                <NavLink to={`/${currentLang}/alltours`}>
                {translation[currentLang].navtours}
                </NavLink>
              </li>
              <li>
                <NavLink to={`/${currentLang}/posts`}>
                  Intagram
                </NavLink>
              </li>
              <li>
                <NavLink to={`/${currentLang}/aboutus`}>
                {translation[currentLang].navaboutus}
                </NavLink>
              </li>
              <li>
                <NavLink to={`/${currentLang}/contact`}>
                {translation[currentLang].navcontact}
                </NavLink>
              </li>
            </ul>
          </div>
          <div className="followus-div">
            <h2>follow us</h2>
            <ul>
              <li>
                <i class="fa-brands fa-instagram"></i>
                <a
                  target="_blank"
                  href="https://www.instagram.com/joyfultravel.az/"
                >
                  Instagram
                </a>
              </li>
              <li>
                <i class="fa-brands fa-whatsapp"></i>
                <a target="_blank" href="https://wa.me/994555074499">
                  WhatsApp
                </a>
              </li>
              <li>
                <i class="fa-brands fa-facebook"></i>
                <a
                  target="_blank"
                  href="https://www.facebook.com/joyful.travel.baku"
                >
                  Facebook
                </a>
              </li>
              <li>
                <i class="fa-brands fa-tiktok"></i>
                <a target="_blank" href="https://www.tiktok.com/@joyfultravel.az?_t=ZS-8v5UVd7lYiA&_r=1">Tiktok</a>
              </li>
            </ul>
          </div>
          <div className="contactus-div">
            <h2>{translation[currentLang].contactus}</h2>
            <ul>
              <li>
                <i class="fa-solid fa-envelope"></i>
                <a href="#">info@joyfultravel.az</a>
              </li>
              <li>
                <i class="fa-solid fa-phone"></i>
                <a href="#">055 507 44 99</a>
              </li>
              <li>
                <i class="fa-solid fa-location-dot"></i>
                <a href="#">Baku, Azerbaijan - Nariman Narimanov district</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="copyright-div">
          &copy; {translation[currentLang].footercopyright}
        </div>
      </footer>
    </>
  );
};

export default Footer;
